import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent, ContentService, HelperService, Order, OrderService, UserService } from "@mypxplat/xplat/core";

import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-order-detail",
  templateUrl: "order-detail.component.html",
  standalone: false,
})
export class OrderDetailComponent extends BaseComponent implements OnInit {
  @Input() order: Order;
  @Output() goBackClicked = new EventEmitter<void>();
  constructor(
    userService: UserService,
    public activatedRoute: ActivatedRoute,
    public contentService: ContentService,
    public helperService: HelperService,
    public appService: AppService,
    private _router: Router,
    public orderService: OrderService
  ) {
    super(userService);
  }

  ngOnInit() {}

  goBack() {
    this.order = null;
    this.goBackClicked.emit();
  }
}
